import { NavLink } from "react-router-dom";
import { CloseIcon } from "../../components/kits/Icons/Icons";
import "./AboutUs.scss";
import { SabadiTextIcon } from "../../components/kits/Icons/Icons";
export default function AboutUs({}) {
  return (
    <>
      <div className="pd-20 ParentAboutUs">
        <NavLink to={"/user-profile"}>
          <div className="mr-t-8">
            <CloseIcon></CloseIcon>
          </div>
        </NavLink>

        <div className="mr-t-16">
          <SabadiTextIcon width={115} height={56}></SabadiTextIcon>
        </div>
        <div className="mr-t-12 title-aboutUs title-h3-m">درباره ما</div>

        <div className="description mr-t-12 desc-c-l">
          سبدی در حوزه عرضه محصولات پر مصرف خانگی و با فروش اینترنتی از سال 1400
          در شمال کشور آغاز بکار کرده است . ثبت سفارش از طریق پلت فرم سبدی
          www.sabadi.ir در وبسایت و نسخه اندروید و ios امکان پذیر هست. ما در
          سبدی محصولات سوپرمارکتی رو از مارکت های مختلف شهر به صورت آنلاین بفروش
          میرسونیم. هدف از ایجاد سبدی و فروش آنلاین محصولات: با توجه به رشد
          جمعیت شهرها مانند کلان شهر ها ، با سفرها و ترافیک های درون شهری زیادی
          مواجه هستیم. بجهت صرفه جویی و برنامه ریزی بهتر و مقایسه بیشتر قیمت و
          کیفیت مناسب کالا ها در زمان خرید، دوری از هرج و مرج ترافیک ، آلودگی
          هوا و آسودگی بیشتر ، بستر فروش آنلاین سبدی با ارائه خدمات ویژه ایجاد
          شده است. همچنین با هدف ارائه محصولات با کیفیت بالاتر به مصرف کننده
          نهایی ، فروشگاه های معتبر برای عرضه محصولات انتخاب شده است. قیمت و
          تخفیفات ویژه ارائه شده امکان مقایسه فروشگاه ها و محصولات آنها را به
          مصرف کنندگان می دهد. یکی از مهمترین ویژگی های سبدی ارائه سبد
          محصولات(پیشنهاد پکیج ویژه) با تخفیف بالاتر نسبت به قیمت هر کالای موجود
          در سبد توسط هر فروشگاه است. این خرید با صرفه ترین خرید ویژه مصرف
          کنندگان آن می باشد. منتظر خدمات ویژه و استثنایی در سبدی باشید...!
        </div>
      </div>
    </>
  );
}
